import { HydrateAction, hydrateType } from '@spa/lib/store/HydrateAction';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PageTemplate } from '@spa/lib/cms/const';
import { RouterState } from './RouterState';

const initialState: RouterState = {
  anyVisitedPageWasCached: false,
  isNavigating: false,
  lastPageLoadServerTimeStampSecs: null,
  pathname: '/',
  pageTemplate: PageTemplate.ONE_COLUMN
};

export interface SetLastPageLoadServerTimeStampSecsPayload {
  readonly lastPageLoadServerTimeStampSecs: number;
}

export const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    routeChangeStart(state) {
      state.isNavigating = true;
    },
    routeChangeComplete(state) {
      state.isNavigating = false;
    },
    setLastPageLoadServerTime(
      state,
      action: PayloadAction<SetLastPageLoadServerTimeStampSecsPayload>
    ) {
      state.lastPageLoadServerTimeStampSecs = action.payload.lastPageLoadServerTimeStampSecs;
    },
    setAnyVisitedPageWasCached(state, action: PayloadAction<boolean>) {
      state.anyVisitedPageWasCached = action.payload;
    },
    setPathname(state, action: PayloadAction<string>) {
      state.pathname = action.payload;
    },
    setPageTemplate(state, action: PayloadAction<PageTemplate>) {
      state.pageTemplate = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrateType, (state, action: HydrateAction) => {
        if (!action.payload.router) {
          return;
        }
        const lastPageLoadServerTimeStampSecs =
          action.payload.router.lastPageLoadServerTimeStampSecs;
        if (lastPageLoadServerTimeStampSecs !== null) {
          state.lastPageLoadServerTimeStampSecs = lastPageLoadServerTimeStampSecs;
        }

        if (action.payload.router.anyVisitedPageWasCached) {
          state.anyVisitedPageWasCached = true;
        }

        if (typeof action.payload.router.pathname !== 'undefined') {
          state.pathname = action.payload.router.pathname;
        }

        if (typeof action.payload.router.pageTemplate !== 'undefined') {
          state.pageTemplate = action.payload.router.pageTemplate;
        }

        if (typeof window !== 'undefined') {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (window as any).BSTR_ANY_VISITED_PAGE_WAS_CACHED = state.anyVisitedPageWasCached;
        }
      })
      .addDefaultCase(() => {});
  }
});

export const {
  routeChangeStart,
  routeChangeComplete,
  setAnyVisitedPageWasCached,
  setLastPageLoadServerTime,
  setPageTemplate,
  setPathname
} = routerSlice.actions;

export default routerSlice.reducer;
